import React, { useEffect, useState } from 'react'
import './WorkSpaceAccess.css'
import { Header, SideBar } from 'CommonComponent';
import { Button, Image } from 'react-bootstrap';
import WorkAccessListing from './component/WorkAccessListing';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import AccessRights from 'utils/AccessRights';
import AccessPage from './component/AccessWorkSpace/component/AccessPage';

const WorkSpaceAccess = () => {

  return (
    <>
      <div className="pt-5 w-100">
        <div className="d-flex justify-content-between align-items-center mb-5 page-heading">
          <h1 className="font-24 font-weight-s-bold">Workspace Access</h1>
          {/* { (AccessRights(session.current_page_permissions, 'add'))?
            <Link to='/AccessPage'><Button className='border-0 gradient-btn text-white' variant='none'><Image src='/assets/images/add-icon.svg' className='me-2 add-user-icon' />Add New</Button></Link> */}
          {/* : ''} */}
        </div>
        <WorkAccessListing />
      </div>
    </>
  )
}

export default WorkSpaceAccess
